import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=1c88050a&scoped=true&"
import script from "./MobileMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=1c88050a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88050a",
  null
  
)

export default component.exports